export function makeInflect(singular: string, plural: string, rest: string) {
	return function (count: number): string {
		const absCount = Math.abs(count);
		if (absCount === 1) {
			return singular;
		} else if (absCount >= 2 && absCount <= 4) {
			return plural;
		} else {
			return rest;
		}
	};
}
